export enum EBuildingCranageType {
  Overhead = 1,
  Beam = 2,
  Railway = 3,
  Goat = 4,
}
